<template>
  <Teleport to="body">
    <Transition
        name="fade"
    >
      <div
          v-if="modal.component"
          aria-modal="true"
          class="fixed right-0 bottom-0 left-0 z-50 flex h-screen items-end md:max-h-full md:w-full md:items-center md:justify-center md:overflow-y-auto md:overflow-x-hidden md:p-4 bg-overlay md:inset-0"
          role="dialog"
          tabindex="-1"
          @click.self="modal.closeModal">
        <component
            :is="modal.component"
            v-bind="modal.props"
        />
      </div>
    </Transition>
  </Teleport>

</template>

<script lang="ts" setup>
import {useModalStore} from "~/store/modal";

const modal = useModalStore()
</script>

<style>
.bg-overlay {
  background: rgba(16, 19, 43, 0.8);
}
</style>

<style scoped>

.fade-enter-active,
.fade-leave-active {
  transition: 0.25s ease opacity;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active .slide,
.fade-leave-active .slide {
  transition: 0.35s ease-in-out all;
}

.fade-enter-from .slide,
.fade-leave-to .slide {
  bottom: -500px;
}

@media screen(md) {
  .fade-enter-active .slide,
  .fade-leave-active .slide {
    transition: none;
  }

  .fade-enter-from .slide,
  .fade-leave-to .slide {
    bottom: 0;
  }
}
</style>
